
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import {
    ADD_COMMAND
} from './map';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const SELECTION_OPERATION_ACTION_TYPE = createActionTypes('selection/OPERATION');
export const SELECTION_ADD_ACTION_TYPE = 'selection/ADD';
export const SELECTION_CLEAR_ACTION_TYPE = 'selection/CLEAR';
export const SELECTION_FILTER_ACTION_TYPE = 'selection/FILTER';
export const SELECTION_GET_ACTION_TYPE = 'selection/GET';
export const SELECTION_REMOVE_ACTION_TYPE = 'selection/REMOVE';
export const SELECTION_REPLACE_ACTION_TYPE = 'selection/REPLACE';

export default function getActions(dispatch) {
    return {
        selectionAdd: (token, projectId, parId) => dispatch({
            type: SELECTION_ADD_ACTION_TYPE, token, projectId, parId
        }),
        selectionClear: (token, projectId) => dispatch({
            type: SELECTION_CLEAR_ACTION_TYPE, token, projectId
        }),
        selectionFilter: (token, projectId, parId) => dispatch({
            type: SELECTION_FILTER_ACTION_TYPE, token, projectId, parId
        }),
        selectionGet: (token, projectId) => dispatch({
            type: SELECTION_GET_ACTION_TYPE, token, projectId
        }),
        selectionRemove: (token, projectId, parId) => dispatch({
            type: SELECTION_REMOVE_ACTION_TYPE, token, projectId, parId
        }),
        selectionReplace: (token, projectId, parId) => dispatch({
            type: SELECTION_REPLACE_ACTION_TYPE, token, projectId, parId
        })
    };
}

function selectionAdd(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionAdd',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId,
                    parId: action.parId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function selectionClear(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionClear',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function selectionFilter(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionFilter',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId,
                    parId: action.parId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function selectionGet(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionGet',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function selectionRemove(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionRemove',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId,
                    parId: action.parId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function selectionReplace(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'selectionReplace',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId,
                    parId: action.parId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workSelectionOperation(options, func, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(func, options.serverApi, action);
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
        yield put({type: ADD_COMMAND, name: 'REDRAW', params: {layers: ['selection_parcela']}});
    } catch (error) {
        yield call(setOperationError, error, SELECTION_OPERATION_ACTION_TYPE);
    }
}

export function* watchSelectionAdd(options) {
    yield takeEvery(
        SELECTION_ADD_ACTION_TYPE, workSelectionOperation, options,
        selectionAdd, 'Přidání parcel do výběru'
    );
}

export function* watchSelectionClear(options) {
    yield takeEvery(
        SELECTION_CLEAR_ACTION_TYPE, workSelectionOperation, options,
        selectionClear, 'Odstranění všech parcel z výběru'
    );
}

export function* watchSelectionFilter(options) {
    yield takeEvery(
        SELECTION_FILTER_ACTION_TYPE, workSelectionOperation, options,
        selectionFilter, 'Filtrování parcel ve výběru'
    );
}

function* workSelectionGet(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(selectionGet, options.serverApi, action);
        yield put({type: SELECTION_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, SELECTION_OPERATION_ACTION_TYPE);
    }
}

export function* watchSelectionGet(options) {
    yield takeEvery(SELECTION_GET_ACTION_TYPE, workSelectionGet, options);
}

export function* watchSelectionRemove(options) {
    yield takeEvery(
        SELECTION_REMOVE_ACTION_TYPE, workSelectionOperation, options,
        selectionRemove, 'Odstranění parcel z výběru'
    );
}

export function* watchSelectionReplace(options) {
    yield takeEvery(
        SELECTION_REPLACE_ACTION_TYPE, workSelectionOperation, options,
        selectionReplace, 'Nahrazení parcel ve výběru'
    );
}
